/** Your settings, the signed-in person's own profile and preferences. */
export const SETTINGS_ROUTE = '/settings';
